"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Icon_1 = __importDefault(require("../../base/Icon/Icon"));

var PageForwards_1 = __importDefault(require("./styledComponents/PageForwards"));

var PageBackwards_1 = __importDefault(require("./styledComponents/PageBackwards"));

var PagingResultsStatus_1 = __importDefault(require("./styledComponents/PagingResultsStatus"));

var PageSizeWrapper_1 = __importDefault(require("./styledComponents/PageSizeWrapper"));

var PageSizeLabel_1 = __importDefault(require("./styledComponents/PageSizeLabel"));

var PageSizeSelector_1 = __importDefault(require("./styledComponents/PageSizeSelector"));

var PageSelector_1 = __importDefault(require("./styledComponents/PageSelector"));

var PageSelectorPrefix_1 = __importDefault(require("./styledComponents/PageSelectorPrefix"));

var PageSelectorSuffix_1 = __importDefault(require("./styledComponents/PageSelectorSuffix"));

var PageSelectorWrapper_1 = __importDefault(require("./styledComponents/PageSelectorWrapper"));

var PageNavigation_1 = __importDefault(require("./styledComponents/PageNavigation"));

var Paging_meta_1 = require("./Paging.meta");

var mobx_1 = require("mobx");

var ButtonFlat_1 = __importDefault(require("../../base/ButtonFlat/ButtonFlat"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var Translate_1 = __importDefault(require("../Translate"));

var Paging =
/** @class */
function (_super) {
  __extends(Paging, _super);

  function Paging(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Paging_meta_1.PAGING_CATEGORY_KEY;
    _this.componentKey = Paging_meta_1.PAGING_COMPONENT_KEY;
    _this.currentIndex = 0;
    _this.pageSize = 10;

    _this.fireOnChange = function () {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(_this.currentIndex, _this.pageSize);
      }
    };

    _this.handlePageBackward = function () {
      var pageBackward = _this.props.pageBackward;
      _this.currentIndex = Math.max(_this.currentIndex - _this.pageSize, 0);

      if (pageBackward) {
        pageBackward(_this.currentIndex);
      }

      _this.fireOnChange();
    };

    _this.handlePageForward = function () {
      var _a = _this.props,
          pageForward = _a.pageForward,
          onChange = _a.onChange;
      _this.currentIndex = _this.currentIndex + _this.pageSize;

      if (pageForward) {
        pageForward(_this.currentIndex);
      }

      _this.fireOnChange();
    };

    _this.handlePageSizeChange = function (items) {
      var item = mobx_1.isArrayLike(items) ? items[0] : items;
      var newPageSize = parseInt(item.value, 10);
      _this.pageSize = newPageSize;
      _this.currentIndex = 0;

      _this.fireOnChange();
    };

    _this.handlePageChange = function (items) {
      var item = mobx_1.isArrayLike(items) ? items[0] : items;
      var newPage = parseInt(item.value, 10);
      var newIndex = (newPage - 1) * _this.pageSize;
      _this.currentIndex = newIndex;

      _this.fireOnChange();
    };

    _this.pageSize = props.pageSize || _this.pageSize;
    _this.currentIndex = props.currentIndex || _this.currentIndex;
    return _this;
  }

  Paging.prototype.componentDidUpdate = function (previousProps) {
    var _a = this.props,
        pageSize = _a.pageSize,
        totalRows = _a.totalRows,
        currentIndex = _a.currentIndex;
    var pageSizeChanged = pageSize !== undefined && previousProps.pageSize !== pageSize;
    var totalRowsChanged = totalRows !== undefined && previousProps.totalRows !== totalRows;
    var currentIndexChanged = currentIndex !== undefined && previousProps.currentIndex !== currentIndex;

    if (pageSizeChanged || totalRowsChanged || currentIndexChanged) {
      this.currentIndex = !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(currentIndex) ? currentIndex : this.currentIndex;
      this.pageSize = pageSize || this.pageSize;
    }
  };

  Object.defineProperty(Paging.prototype, "pageBackwardsButton", {
    get: function get() {
      var disabled = this.currentIndex <= 0;
      var asset = disabled ? 'base.paging.leftArrowDisabled' : 'base.paging.leftArrow';
      return react_1.default.createElement(PageBackwards_1.default, null, react_1.default.createElement(ButtonFlat_1.default, {
        onClick: this.handlePageBackward,
        disabled: disabled
      }, react_1.default.createElement(Icon_1.default, {
        asset: asset,
        alt: '<'
      })));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "pageForwardsButton", {
    get: function get() {
      var totalRows = this.props.totalRows;
      var disabled = totalRows <= this.currentIndex + this.pageSize;
      var asset = disabled ? 'base.paging.rightArrowDisabled' : 'base.paging.rightArrow';
      return react_1.default.createElement(PageForwards_1.default, null, react_1.default.createElement(ButtonFlat_1.default, {
        onClick: this.handlePageForward,
        disabled: disabled
      }, react_1.default.createElement(Icon_1.default, {
        asset: asset,
        alt: '>'
      })));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "pageSizeSelection", {
    get: function get() {
      var _this = this;

      var pageSizeSelection = this.props.pageSizeSelection;

      if (pageSizeSelection) {
        var label = pageSizeSelection.label;
        return react_1.default.createElement(PageSizeWrapper_1.default, null, react_1.default.createElement(PageSizeLabel_1.default, null, label), react_1.default.createElement(PageSizeSelector_1.default, {
          onChange: this.handlePageSizeChange,
          selectedItem: this.pageSizeOptions.find(function (option) {
            return option.value === _this.pageSize.toString();
          }),
          items: this.pageSizeOptions
        }));
      }

      return null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "pageSizeOptions", {
    get: function get() {
      var _a = this.props.pageSizeSelection,
          pageSizeSelection = _a === void 0 ? {} : _a;
      var options = pageSizeSelection.options;

      if (!options) {
        options = [this.pageSize];
      }

      return options.map(function (value) {
        return {
          value: value.toString(),
          label: value.toString()
        };
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "pageSelection", {
    get: function get() {
      var _this = this;

      var pageSelection = this.props.pageSelection;

      if (pageSelection && pageSelection.enabled) {
        var prefix = pageSelection.prefix,
            suffix = pageSelection.suffix;
        var totalPages = this.totalPages;
        return react_1.default.createElement(PageSelectorWrapper_1.default, null, prefix && react_1.default.createElement(PageSelectorPrefix_1.default, null, react_1.default.createElement(Translate_1.default, null, ksys_app_template_1.utils.replacePlaceholders(this.placeholders, prefix))), react_1.default.createElement(PageSelector_1.default, {
          onChange: this.handlePageChange,
          selectedItem: this.pageOptions.find(function (option) {
            return option.value === _this.currentPage.toString();
          }),
          items: this.pageOptions
        }), suffix && react_1.default.createElement(PageSelectorSuffix_1.default, null, react_1.default.createElement(Translate_1.default, null, ksys_app_template_1.utils.replacePlaceholders(this.placeholders, suffix))));
      }

      return null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "currentPage", {
    get: function get() {
      var currentPage = Math.ceil((this.currentIndex + 1) / this.pageSize);
      return currentPage;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "pageOptions", {
    get: function get() {
      var options = [];
      var totalPages = this.totalPages;

      for (var i = 1; i <= totalPages; i++) {
        var pageNumber = i.toString();
        options.push({
          value: pageNumber,
          label: pageNumber
        });
      }

      return options;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "totalPages", {
    get: function get() {
      return Math.ceil(this.totalRows / this.pageSize);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "totalRows", {
    get: function get() {
      return this.props.totalRows || 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "firstItem", {
    get: function get() {
      return Math.min(this.totalRows, this.currentIndex + 1);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "lastItem", {
    get: function get() {
      return Math.min(this.totalRows, this.currentIndex + this.pageSize);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Paging.prototype, "placeholders", {
    get: function get() {
      return {
        firstItem: this.firstItem,
        lastItem: this.lastItem,
        totalRows: this.totalRows,
        totalPages: this.totalPages
      };
    },
    enumerable: true,
    configurable: true
  });

  Paging.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        totalRows = _a.totalRows,
        _b = _a.pagingLabelFormat,
        pagingLabelFormat = _b === void 0 ? '{firstItem} - {lastItem} / {totalRows}' : _b;
    var pagingResultsStatus = ksys_app_template_1.utils.replacePlaceholders(this.placeholders, pagingLabelFormat);
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, this.pageSizeSelection, react_1.default.createElement(PagingResultsStatus_1.default, null, pagingResultsStatus), react_1.default.createElement(PageNavigation_1.default, null, this.pageBackwardsButton, this.pageSelection, this.pageForwardsButton));
  };

  __decorate([mobx_1.observable], Paging.prototype, "currentIndex", void 0);

  __decorate([mobx_1.observable], Paging.prototype, "pageSize", void 0);

  __decorate([mobx_1.action], Paging.prototype, "fireOnChange", void 0);

  __decorate([mobx_1.action], Paging.prototype, "handlePageBackward", void 0);

  __decorate([mobx_1.action], Paging.prototype, "handlePageForward", void 0);

  __decorate([mobx_1.action], Paging.prototype, "handlePageSizeChange", void 0);

  __decorate([mobx_1.action], Paging.prototype, "handlePageChange", void 0);

  __decorate([mobx_1.computed], Paging.prototype, "pageBackwardsButton", null);

  __decorate([mobx_1.computed], Paging.prototype, "pageForwardsButton", null);

  __decorate([mobx_1.computed], Paging.prototype, "pageSizeSelection", null);

  __decorate([mobx_1.computed], Paging.prototype, "pageSizeOptions", null);

  __decorate([mobx_1.computed], Paging.prototype, "pageSelection", null);

  __decorate([mobx_1.computed], Paging.prototype, "currentPage", null);

  __decorate([mobx_1.computed], Paging.prototype, "pageOptions", null);

  __decorate([mobx_1.computed], Paging.prototype, "totalPages", null);

  __decorate([mobx_1.computed], Paging.prototype, "totalRows", null);

  __decorate([mobx_1.computed], Paging.prototype, "firstItem", null);

  __decorate([mobx_1.computed], Paging.prototype, "lastItem", null);

  __decorate([mobx_1.computed], Paging.prototype, "placeholders", null);

  Paging = __decorate([mobx_react_1.observer], Paging);
  return Paging;
}(shared_1.ComponentBase);

exports.Paging = Paging;
exports.default = shared_1.InjectedStyledComponent(Paging, Paging_meta_1.PAGING_CATEGORY_KEY, Paging_meta_1.PAGING_COMPONENT_KEY);